module.exports = __webpack_public_path__ + "img/title-3.b11838be.png";